import { axiosInstance } from "./index";
import { ApiRequest } from "./types";

export const createAgreement = async (params: ApiRequest.CreateAgreement) => {
  const response = await axiosInstance.post(
    `/api/agreement/${params.service_term_id}/partner_users/${params.partner_user_id}`
  );
  return response;
};
